// The Return Status stage choice in the admin agent draft column (2026-10-29,
// docs/agent-draft-shadow.md "The stage choice for an existing RMA"). The
// step preview (server/src/ai/shadow-step-previews.js's returnStagePreview())
// carries the options, the preselection and the reply per stage; the column
// shows the main panel's controls (TaskPathChoiceControls.jsx) and the reply
// follows the choice, as the main panel's does: the chosen stage's reply with
// the carrier's date filled (@cxhub/shared's fillReturnStageDates(), the
// main panel's own fill), and before a choice a line saying it waits. Pure,
// so ui/test can run it.
import { fillReturnStageDates, returnStagePathKey } from '@cxhub/shared'

// Whether a step shows for the stage choice (2026-10-29, the Return Status
// overdue refund): a step on the overdue path (preview.stagePath) only when
// the stage is delivered and its date is past the window, as on the main
// panel (@cxhub/shared's returnStagePathKey()). Every other step shows.
export function shadowStageStepShown(preview, stageStep, values = {}, today = undefined) {
  if (!preview?.stagePath) return true
  const choiceStep = { params: { kind: 'return_stage', refundOverdue: stageStep?.options?.refundOverdue ?? null } }
  return returnStagePathKey(choiceStep, { choice: values?.stage ?? null, date: values?.date ?? null }, today) === preview.stagePath
}

export const STAGE_REPLY_PLACEHOLDER = 'Choose where the return is to see the reply.'

// The controls' props for the step and its current values: { options,
// value, date, preselected }. An option needs its date unless it says not.
export function shadowStageChoice(preview, values = {}) {
  const options = (preview?.options?.stages ?? []).map((o) => ({ ...o, dateRequired: o.dateRequired !== false, dateLabel: o.dateLabel ?? 'Date' }))
  const value = values?.stage && options.some((o) => o.value === values.stage) ? values.stage : null
  return { options, value, date: typeof values?.date === 'string' ? values.date : '', preselected: preview?.options?.preselected ?? null }
}

// The reply the column shows for the choice: null when the step has no
// reply per stage, or the person marked it "My reply doesn't need this"
// (the agent's own reply shows); { text: '' } before a choice (or for a
// stage with no reply); { text, stage } once chosen, its date filled when
// it is a date.
export function shadowStageReply(preview, values = {}) {
  const replies = preview?.options?.replies ?? {}
  if (!Object.keys(replies).length || values?.notNeeded === true) return null
  const { value, date } = shadowStageChoice(preview, values)
  if (!value || typeof replies[value] !== 'string') return { text: '', stage: value }
  return { text: fillReturnStageDates(replies[value], { stage: value, date }), stage: value }
}
